export default __webpack_public_path__ + "static/media/imgInstrumento.fbc2c775.png";